import React from "react";
import { Accordion, AccordionSet, Button, RadioButton, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { ProvisionalFilterAccordion } from "../filters/ProvisionalFilterAccordion";
import { TitleNameFilterAccordion } from "../filters/TitleNameFilterAccordion";
export var PERIODICAL_CHECK_STATUS_OPTIONS = [
    "OPEN",
    "POSTPONED",
    "CLOSED",
];
export var PeriodicalCheckFilters = function (_a) {
    var filters = _a.filters, hasUnappliedChanges = _a.hasUnappliedChanges, onNameChange = _a.onNameChange, onStatusChange = _a.onStatusChange, onProvisionalChange = _a.onProvisionalChange, onApplyFilters = _a.onApplyFilters;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(TitleNameFilterAccordion, { id: "periodical-check-filter-name", value: filters.name, onChange: onNameChange }),
            React.createElement(Accordion, { id: "periodical-check-filter-status", label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.filter.label",
                }), separator: false }, PERIODICAL_CHECK_STATUS_OPTIONS.map(function (status) { return (React.createElement(RadioButton, { key: status, name: "periodicalCheckStatus", value: status, checked: filters.status === status, onChange: function () { return onStatusChange(status); }, label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.status.".concat(status),
                }) })); })),
            React.createElement(ProvisionalFilterAccordion, { titleType: "PERIODICAL", checked: filters.provisional, onChange: onProvisionalChange })),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.apply" }))));
};
